import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';

const GOOGLE_DOCS_URL = 'https://triptripfiles.blob.core.windows.net/tnc-files/TripTrip_PrivacyPolicy.pdf#toolbar=0&navpanes=0&scrollbar=0';

const PrivacyModal = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="body">
      <DialogTitle>Privacy Policy</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ width: '100%', height: '70vh' }}>
          <iframe
            src={GOOGLE_DOCS_URL}
            title="TripTrip India Privacy Policy"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrivacyModal; 